module.exports = __webpack_public_path__ + "img/more.06c43255.png";